package com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.platform.text.mappers.SpannableStringKmpToAnnotatedStringMapper
import com.eladfinish.bible.contest.text.ClickAction
import com.eladfinish.bible.contest.text.SpannableStringKMP
import com.eladfinish.bible.contest.ui.components.mouseVerticalScrollbar
import com.eladfinish.bible.contest.ui.extensions.navigationBarInsetPadding

@Composable
internal fun ChapterCompleteText(
    model: SpannableStringKMP,
    scrollState: ScrollState,
    textAlign: TextAlign?,
    textSize: Float,
    onActionClick: (ClickAction) -> Unit,
) {

    val kmpToAnnotatedMapper = remember { SpannableStringKmpToAnnotatedStringMapper() }

    val baseStyle = LocalTextStyle.current

    val mapped = remember(model, textSize) {
        kmpToAnnotatedMapper(
            model = model,
            baseTextSize = textSize.sp,
        )
    }

    var layoutResult by remember { mutableStateOf<TextLayoutResult?>(null) }

    SelectionContainer {
        Text(
            text = mapped.annotatedString,
            modifier = Modifier
                .fillMaxSize()
                .mouseVerticalScrollbar(scrollState)
                .verticalScroll(scrollState)
                .navigationBarInsetPadding()
                .padding(16.dp)
                .pointerInput(mapped, layoutResult) {
                    // Detect taps on click annotations
                    detectTapGestures { pos ->
                        val layout = layoutResult ?: return@detectTapGestures
                        val offset = layout.getOffsetForPosition(pos)

                        val annotation = mapped.annotatedString.getStringAnnotations(
                            tag = SpannableStringKmpToAnnotatedStringMapper.TAG_CLICK,
                            start = offset,
                            end = offset,
                        )
                            .firstOrNull()
                            ?: return@detectTapGestures

                        val action = mapped.actionsById[annotation.item] ?: return@detectTapGestures
                        onActionClick(action)
                    }
                },
            textAlign = textAlign,
            fontSize = textSize.sp,
            style = baseStyle,
            onTextLayout = { layoutResult = it },
        )
    }
}
